module.exports = __webpack_public_path__ + "img/amandine-henry.7ff63015.png";